import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var WithdrawnItem = function (props) {
    var i18n = props.i18n, withdrawnCase = props.withdrawnCase;
    var author = withdrawnCase.author;
    var description = withdrawnCase.cancellationCode
        ? getPropsByKeyPath(i18n, 'modules.timeline.withdrawnCase.textActionWithStatusDetails')
            .replace('$username ', '')
            .replace('$moStatusDetails', '')
        : getPropsByKeyPath(i18n, 'modules.timeline.withdrawnCase.textAction').replace('$username ', '');
    var authorLabel = (author === null || author === void 0 ? void 0 : author.login) || getPropsByKeyPath(i18n, 'modules.timeline.defaultUser');
    var abortReason = withdrawnCase.cancellationCode
        ? getPropsByKeyPath(i18n.keyValueMap, "filter.moStatus.details.".concat(withdrawnCase.cancellationCode))
        : null;
    return (_jsxs("p", { children: [_jsx("b", { children: authorLabel }), " ", description, " ", abortReason && _jsx("b", { children: abortReason })] }));
};
